export default "__VITE_ASSET__da7360ef__"